// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__2AELS","meals-appear":"AvailableMeals_meals-appear__C1exW"};